import * as React from 'react';
import {Select} from 'antd';
import locales from '../../locales';
import {OptionProps, SelectValue} from 'antd/lib/select';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';

interface SelectFormItemProps extends BaseFormItemProps {
  options?: OptionProps[];
  onSelect?: (value: SelectValue, option: React.ReactElement<any>) => any;
  allowClear?: boolean;
}

class SelectFormItem extends React.Component<SelectFormItemProps, {}> {

  public render(): React.ReactNode {
    const {disabled, options, onSelect, allowClear} = this.props;
    return <BaseFormItem
      {...this.props}
      input={
        <Select
          onSelect={onSelect}
          placeholder={locales.choose}
          className="mild-disabled"
          disabled={disabled}
          allowClear={allowClear}
        >
          {options && options.map(opt => {
            return (
              <Select.Option {...opt} key={String(opt.value)}>{opt.title}</Select.Option>
            )
          })}
        </Select>
      }
    />;
  }
}

export default SelectFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/SelectFormItem.tsx